<template>
  <div class="container">
    <div class="tabcontainer">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多啦"
        @load="load_more"
      >
        <div
          v-for="(item, index) in collection"
          :key="item.id"
          style="margin-bottom: 10px"
          class="main"
          @click="linkid(item.id)"
        >
          <div class="tabflexdiv" style="font-size: 14px">
            <p class="topic" style="font-weight: bold">{{ item.title }}</p>
            <p class="label">{{ item.type }}</p>
          </div>
          <div class="tabflexdiv">
            <div class="left">
              <div class="picdiv">
                <img :src="item.img" alt="" />
                <!-- 状态标签 -->
                <div
                  class="status"
                  v-show="item.zt == 1"
                  :class="{ active01: item.zt == 1 }"
                >
                  <p>报名中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 2"
                  :class="{ active02: item.zt == 2 }"
                >
                  <p>进行中</p>
                </div>
                <div
                  class="status"
                  v-show="item.zt == 3"
                  :class="{ active03: item.zt == 3 }"
                >
                  <p>已完成</p>
                </div>
              </div>
              <div class="tabflexdiv" style="margin-top: 10px">
                <div @click.stop="fan(item.id, index)">
                  <i v-show="item.fan == 2" class="el-icon-star-off"></i>
                  <i
                    v-show="item.fan == 1"
                    class="el-icon-star-on"
                    style="color: red"
                  ></i>
                  <span>点击收藏</span>
                </div>
                <div
                  @click.stop="
                    showShare = true;
                    share(
                      item.title,
                      item.starttime_fmt,
                      item.endtime_fmt,
                      item.range_str,
                      item.address,
                      item.org_name,
                      item.total_count,
                      item.id,
                      item.img
                    );
                  "
                >
                  <i class="el-icon-position"></i>
                  <span>一键转发</span>
                </div>
              </div>
            </div>
            <div class="right">
              <p>活动开始时间：</p>
              <p>{{ item.starttime_fmt }}</p>
              <p>活动范围：{{ item.range_str }}</p>
              <p>发起组织：{{ item.org_name }}</p>
              <p>
                报名人数：{{ item.count
                }}<span v-if="item.total_count">/{{ item.total_count }}</span
                >人
              </p>
              <el-button
                v-show="item.isclose == 0 && item.btn != 0"
                type="primary"
                >{{ item.btn_str }}</el-button
              >
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 分享面板 -->
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onShareSelect"
    />
    <!-- 分享海报 -->
    <vue-canvas-poster
      :widthPixels="1000"
      :painting="painting"
      @success="success"
      @fail="fail"
    >
    </vue-canvas-poster>
    <van-overlay :show="showposter" @click="showposter = false">
      <img
        class="poster"
        @touchend.prevent="isAndroid && saveimg()"
        saveImage="true"
        :src="posterimg"
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
export default {
  name: "myfav",
  data() {
    return {
      isAndroid: false,
      collection: [],
      loading: false,
      finished: false,
      page: 1,
      appId: "2312",
      url: "",
      showShare: false,
      options: [
        { name: "分享海报", icon: "poster" },
        { name: "其他", icon: "link" },
      ],
      painting: {
        width: `${document.documentElement.clientWidth}px`,
        height: `${document.documentElement.clientWidth * 1.6}px`,
        background: "#fff",
        views: [
          {
            //头像
            type: "image",
            id: "avater",
            url: "",
            css: {
              top: "50px",
              left: `${document.documentElement.clientWidth / 3.1}px`,
              width: `${document.documentElement.clientWidth / 2.8}px`,
              height: `${document.documentElement.clientWidth / 3.5}px`,
            },
          },
          {
            //text1 title
            type: "text",
            text: "",
            css: {
              top: [
                `${document.documentElement.clientWidth / 7 + 20}px`,
                "avater",
              ],
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "20px",
              textAlign: "center",
              maxLines: 1,
            },
          },
          {
            //text2 starttime
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 120}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text3 endtime
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 144}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text4 range
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 168}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text5 address
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 192}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
              maxLines: 1,
            },
          },
          {
            //text6 org
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 216}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
              maxLines: 1,
            },
          },
          {
            //text6 count
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 240}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //rect
            type: "rect",
            text: "",
            css: {
              bottom: `100px`,
              width: `${document.documentElement.clientWidth - 40}px`,
              left: "20px",
              height: "1px",
              color: "grey",
            },
          },
          {
            //qrcode
            type: "qrcode",
            content: "",
            css: {
              bottom: "20px",
              width: "60px",
              height: "60px",
              left: "20px",
            },
          },
          {
            //icon
            type: "image",
            url: "",
            css: {
              bottom: "20px",
              right: "20px",
              width: "60px",
              height: "60px",
            },
          },
          {
            //text
            type: "text",
            text: "①长按保存图片到相册",
            css: {
              bottom: "64px",
              width: `${document.documentElement.clientWidth - 180}px`,
              fontSize: "12px",
              left: "90px",
              color: "#a1a1a1",
            },
          },
          {
            //text
            type: "text",
            text: "②打开最江阴APP扫一扫",
            css: {
              bottom: "24px",
              width: `${document.documentElement.clientWidth - 180}px`,
              fontSize: "12px",
              left: "90px",
              color: "#a1a1a1",
            },
          },
        ],
      },
      posterimg: "",
      showposter: false,
      currentshareevent: {},
    };
  },
  created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    if (isAndroid) {
      this.isAndroid = true;
    }
    var that = this;
    //app
    this.url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";
    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        console.log("初始化成功");
      },
    });
    window.addEventListener("load", function () {
      zjyapi.saveImage();
    });
    /* 我的收藏 */
    this.$axios({
      method: "post",
      url: "/api/task/fav_list",
      data: this.qs.stringify({
        token: sessionStorage.getItem("wmtoken"),
      }),
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.collection = res.data.data.list;
        for (let i in res.data.data.list) {
          this.collection[i].starttime = this.timeTrans(
            this.collection[i].starttime
          );
          this.collection[i].endtime = this.timeTrans(
            this.collection[i].endtime
          );
          this.collection[i].fan = 2;
          this.collection[i].bmstatus = 0;
          if (
            parseInt(new Date().getTime() / 1000) < this.collection[i].starttime
          ) {
            this.collection[i].bmstatus = 0;
          } else if (
            parseInt(new Date().getTime() / 1000) >
              this.collection[i].starttime &&
            parseInt(new Date().getTime() / 1000) < this.collection[i].endtime
          ) {
            this.collection[i].bmstatus = 1;
          } else {
            this.collection[i].bmstatus = 2;
          }
          if (this.collection[i].fav) {
            this.collection[i].fan = 1;
          }
          switch (res.data.data.list[i].type) {
            case 1:
              this.collection[i].type = "志愿者活动";
              break;
            case 2:
              this.collection[i].type = "心愿任务";
              break;
            default:
              break;
          }
        }
      }
    });
  },
  methods: {
    saveimg() {
      console.log("调用saveimage");
      zjyapi.saveImage(true);
    },
    changesharepic() {
      this.$axios({
        method: "post",
        url: "/api/common/uploadbaseimg",
        data: this.qs.stringify({
          base_img: this.posterimg,
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.posterimg = res.data.data.url;
          //this.showposter = true;
        } else {
          //this.$toast('生成海报失败，请重试');
        }
      });
    },
    /* poster */
    share(title, starttime, endtime, range, address, org, count, id, img) {
      this.currentshareevent.title = title;
      this.currentshareevent.starttime = starttime;
      this.currentshareevent.endtime = endtime;
      this.currentshareevent.range = range;
      this.currentshareevent.address = address;
      this.currentshareevent.org = org;
      this.currentshareevent.count = count;
      this.currentshareevent.id = id;
      this.currentshareevent.img = img;
    },
    beginPoster() {
      this.$set(this.painting.views[0], "url", this.currentshareevent.img);
      this.$set(this.painting.views[1], "text", this.currentshareevent.title);
      this.$set(
        this.painting.views[2],
        "text",
        "活动开始时间：" + this.currentshareevent.starttime
      );
      this.$set(
        this.painting.views[3],
        "text",
        "活动结束时间：" + this.currentshareevent.endtime
      );
      this.$set(
        this.painting.views[4],
        "text",
        "活动范围：" + this.currentshareevent.range
      );
      this.$set(
        this.painting.views[5],
        "text",
        "活动地址：" + this.currentshareevent.address
      );
      this.$set(
        this.painting.views[6],
        "text",
        "发起组织：" + this.currentshareevent.org
      );
      this.$set(
        this.painting.views[7],
        "text",
        "参与名额：" + this.currentshareevent.count + "人"
      );
      this.$set(
        this.painting.views[9],
        "content",
        "https://www.jywmsj.com/h5/#/detail?id=" + this.currentshareevent.id
      );
      this.$set(this.painting.views[10], "url", "static/img/icon3.png");
      this.$toast("生成海报中");
      this.showposter = true;
    },
    success(src) {
      //console.log(src);
      this.posterimg = src;
      this.changesharepic();
    },
    fail(err) {
      console.log("fail", err);
    },
    /* posterend */
    onShareSelect(option) {
      console.log(option);
      switch (option.icon) {
        case "poster":
          console.log("poster");
          this.beginPoster();
          break;
        case "link":
          this.showShare = false;
          this.zhuanfa(
            this.currentshareevent.title,
            this.currentshareevent.id,
            this.currentshareevent.img,
            this.currentshareevent.starttime,
            this.currentshareevent.endtime,
            this.currentshareevent.range
          );
        default:
          break;
      }
      this.showShare = false;
    },
    zhuanfa(title, id, img, starttime, endtime, address) {
      this.openShare(
        title,
        "https://www.jywmsj.com/h5/#/detail?id=" + id,
        "https://www.jywmsj.com/" + img,
        starttime,
        endtime,
        address
      );
    },
    linkid(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
        },
      });
    },
    //收藏
    fan(id, index) {
      console.log(index);
      //未收藏状态
      if (this.collection[index].fan == 2) {
        this.$axios({
          method: "post",
          url: "/api/task/fav",
          data: this.qs.stringify({
            task_id: id,
            type: 1,
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            this.collection[index].fan = 1;
            this.$forceUpdate();
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        this.$axios({
          method: "post",
          url: "/api/task/fav",
          data: this.qs.stringify({
            task_id: id,
            type: 2,
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            this.collection[index].fan = 2;
            this.$forceUpdate();
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    timeTrans(time) {
      let date = new Date(parseInt(time) * 1000);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let minute = date.getMinutes();
      let second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      //console.log( y + '-' + m + '-' + d + ' ' + '　' + h + ':' + minute + ':' + second);
      time = y + "/" + m + "/" + d;
      return time;
    },
    load_more() {
      this.page += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/task/fav_list",
            data: that.qs.stringify({
              token: sessionStorage.getItem("wmtoken"),
              page: that.page,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                res.data.data.list[i].starttime = that.timeTrans(
                  res.data.data.list[i].starttime
                );
                res.data.data.list[i].endtime = that.timeTrans(
                  res.data.data.list[i].endtime
                );
                res.data.data.list[i].fan = 2;
                res.data.data.list[i].bmstatus = 0;
                if (
                  parseInt(new Date().getTime() / 1000) <
                  res.data.data.list[i].starttime
                ) {
                  res.data.data.list[i].bmstatus = 0;
                } else if (
                  parseInt(new Date().getTime() / 1000) >
                    res.data.data.list[i].starttime &&
                  parseInt(new Date().getTime() / 1000) <
                    res.data.data.list[i].endtime
                ) {
                  res.data.data.list[i].bmstatus = 1;
                } else {
                  res.data.data.list[i].bmstatus = 2;
                }
                if (res.data.data.list[i].fav) {
                  res.data.data.list[i].fan = 1;
                }
                switch (res.data.data.list[i].type) {
                  case 1:
                    res.data.data.list[i].type = "志愿者活动";
                    break;
                  case 2:
                    res.data.data.list[i].type = "心愿任务";
                    break;
                  default:
                    break;
                }
              }
              that.collection = that.collection.concat(res.data.data.list);
            }
            that.loading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.finished = true;
            } else {
              that.finished = false;
            }
          });
      }, 500);
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    openShare: function (title, url, imgUrl, starttime, endtime, address) {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          sign: sign,
          params: {
            title: title,
            content: `
            ${starttime}-${endtime}
            ${address}
            ${title}
            `,
            url: url, //分享地址
            imgUrl: imgUrl, //分享图标地址
          },
          success: function (ret) {
            console.log("分享成功：" + ret);
            var data = JSON.parse(ret);
            console.log(ret);
            console.log(data);
          },
          error: function (error) {
            console.log("分享失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //app相关end
  },
};
</script>
<style scoped>
.tabcontainer {
  padding: 10px;
  margin-bottom: 50px;
}
.tabflexdiv {
  display: flex;
  justify-content: space-between;
}
.left {
  width: 40vw;
  font-size: 3.5vw;
}
.left img {
  height: 32vw;
  object-fit: contain;
}
.tabcontainer .right {
  width: 53%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.2em;
}
.tabcontainer .right p {
  font-size: 3vw;
}
.tabcontainer .right .el-button {
  width: 60%;
  align-self: flex-end;
  padding: 10px;
}
.main {
  border: 1px solid #eee;
  padding: 10px;
}
.label {
  background: #a5ef99;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 3px 10px;
  margin-right: -11px;
  white-space: nowrap;
}
.picdiv {
  position: relative;
  overflow: hidden;
}
.status {
  font-size: 12px;
  color: white;
  font-weight: bold;
  background: orange;
  text-align: center;
  position: absolute;
  top: 13%;
  left: -33%;
  width: 100%;
  padding: 2px;
  transform: rotate(-45deg);
}
.active01 {
  background: orange;
}
.active02 {
  background: #7dce86;
}
.active03 {
  background: #f26161;
}
img {
  width: 100%;
  display: block;
}
.topic {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.poster {
  width: 80%;
  border-radius: 10px;
  margin: auto;
  margin-top: 10vw;
  -webkit-touch-callout: default;
}
</style>


// WEBPACK FOOTER //
// src/components/myfav.vue